import React from "react";

import "./plecaRC.scss";

const PlecaRC = () => {
    return (
        <section className="pleca-rc">
            <div
                className="pleca-rc__container"
                style={{ backgroundImage: `url('imgs/bg_redco.jpg')` }}
            >
                <div className="pleca-rc__info">
                    <div className="pleca-rc__info-body">
                        <h5 className="">Un producto de</h5>
                        <img
                            // 3. IGUAL AQUÍ: Usamos el string directo
                            src="imgs/redco.png"
                            className="logo"
                            alt="Red Companies"
                        />
                        <div className="content">
                            <p>
                                Somos una empresa orgullosamente mexicana que reúne diferentes
                                productos y disciplinas, mismas que nos complementan y nos
                                hacen ser los mejores para los proyectos de nuestros clientes.
                            </p>
                        </div>
                    </div>

                    <p className="text-center">
                        <a
                            className="btn border"
                            href="http://somosredcompanies.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Conoce Red Companies
                        </a>
                    </p>
                </div>
            </div>
        </section>
    )
}

export default PlecaRC;
